export const GenerationState = {
  SUCCESS: "SUCCESS",
  PENDING: "PENDING",
  PROGRESS: "PROGRESS",
  FAILURE: "FAILURE",
};

export const templateTypeMapping: Record<string, string> = {
  ME: "M&E (Monitoring and Evaluation)",
  PROJECT_UPDATE_QUARTERLY: "Project Update – Quarterly",
  PROJECT_UPDATE_MONTHLY: "Project Update – Monthly",
  FIELD_OBSERVATIONS: "Field Observations",
  ANNUAL_REPORT: "Annual Report",
  FINANCIAL_REPORT: "Financial Report",
};
